<div class="">
  <div class="section-authentication-cover">
    <div class="row align-items-center g-0">
      <div
        class="col-12 col-xl-7 col-xxl-8 auth-cover-left align-items-center justify-content-center d-none d-xl-flex"
      >
        <div class="card shadow-none bg-transparent shadow-none rounded-0 mb-0">
          <div class="card-body">
            <img
              src="assets/images/cdblack.png"
              class="auth-img-cover-login"
              alt="CD-logo"
            />
          </div>
        </div>
      </div>

      <div
        class="col-12 col-xl-5 col-xxl-4 auth-cover-right align-items-center justify-content-center"
      >
        <div class="card rounded-0 m-3 shadow-none bg-transparent mb-0">
          <div class="card-body p-sm-5 p-0">
            <div class="text-center d-lg-none d-block mt-sm-2 mt-0 mylogoimg">
              <a href="index.html"
                ><img src="assets/images/cdblack.png" alt="CD-logo"
              /></a>
            </div>
            <div class="text-center mb-4 mt-lg-auto mt-3">
              <h3 class="mb-lg-3 mb-2">Sign Up</h3>

              <h5
                class="stay-connect d-flex justify-content-center align-items-center flex-wrap gap-2"
              >
                <span>Please create your account ✅</span>
              </h5>
              <form-error [form]="form"></form-error>
            </div>
            <div class="form-body">
              <form
                class="auth-form row g-2"
                *ngIf="!isLogin"
                #signupform="ngForm"
              >
                <!-- First Name -->
                <div class="col-12">
                  <mat-label>First Name</mat-label>
                  <mat-form-field appearance="outline" class="auth-field w-100">
                    <mat-icon matPrefix class="text-secondary opacity-50"
                      >person_outline</mat-icon
                    >
                    <input
                      matInput
                      type="text"
                      id="firstName"
                      name="firstName"
                      placeholder="Enter First Name"
                      [(ngModel)]="form.data['firstName']"
                      required
                    />
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <!-- Last Name -->
                  <mat-label>Last Name</mat-label>
                  <mat-form-field appearance="outline" class="auth-field w-100">
                    <mat-icon matPrefix class="text-secondary opacity-50"
                      >person_outline</mat-icon
                    >

                    <input
                      matInput
                      type="text"
                      id="lastName"
                      name="lastName"
                      placeholder="Enter Last Name"
                      [(ngModel)]="form.data['lastName']"
                      required
                    />
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <!-- Email -->
                  <mat-label>Email</mat-label>
                  <mat-form-field appearance="outline" class="auth-field w-100">
                    <mat-icon matPrefix class="text-secondary opacity-50"
                      >mail_outline</mat-icon
                    >

                    <input
                      matInput
                      type="email"
                      id="loginId"
                      name="loginId"
                      placeholder="Enter Email"
                      [(ngModel)]="form.data['loginId']"
                      required
                      [readOnly]="isreadonly"
                    />
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <!-- Password -->
                  <mat-label>Password</mat-label>
                  <mat-form-field appearance="outline" class="auth-field w-100">
                    <mat-icon matPrefix class="text-secondary opacity-50"
                      >lock_outline</mat-icon
                    >
                    <input
                      matInput
                      [type]="showPassword ? 'text' : 'password'"
                      id="password"
                      name="password"
                      [(ngModel)]="form.data['password']"
                      placeholder="Enter Password"
                      required
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      type="button"
                      class="visibility-btn"
                      (click)="togglePasswordVisibility()"
                    >
                      <mat-icon class="text-secondary">{{
                        showPassword ? "visibility" : "visibility_off"
                      }}</mat-icon>
                    </button>
                  </mat-form-field>
                </div>

                <div class="col-12">
                  <!-- Submit -->
                  <div class="w-100 my-3">
                    <button
                      mat-raised-button
                      color="primary"
                      type="submit"
                      class="w-100 fat-button shadow-sm"
                      (click)="signup()"
                      [disabled]="!signupform.valid"
                    >
                      <span class="fs-6 tracking-wider"> Sign Up</span>
                    </button>
                  </div>
                </div>

                <div class="col-12 text-center mt-2">
                  <p class="mb-0 text-muted">
                    Already have an account?

                    <a
                      routerLink="/login"
                      class="text-decoration-none fw-bold ms-1"
                      style="color: #3f51b5"
                      >Sign in here</a
                    >
                  </p>
                </div>
              </form>

              <div *ngIf="isLogin" class="form-group form-row ml-5">
                <label
                  for="email"
                  class="col-sm-12 col-form-label col-form-label-sm"
                >
                  <h4>Hi, {{ form.data["firstName"] }}</h4>
                  <p>
                    You have been registered, your login id is
                    {{ form.data["loginId"] }}
                  </p>
                  <p>Please click button to login</p>
                </label>
                <a class="btn btn-outline-primary btn-sm" (click)="gotoLogin()"
                  ><i class="fas fa-sign-out-alt"></i>Login</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>